<template>
  <v-form ref="npSettlementEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'delivery-index', params: {tab: 0}})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col  cols="12" sm="5" md="4" xl="3">
        <h1 class="mb-16">{{ npSettlement.id ? 'Редактировать населенный пункт НП' : 'Создать населенный пункт НП'}}</h1>
        <v-tabs v-model="tabLang">
          <v-tab>RU</v-tab>
          <v-tab>UA</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabLang" class="mt-4 mb-2">
          <v-tab-item :eager="true">
            <v-row>
              <v-col>
                <v-text-field
                        v-model="npSettlement.name"
                        label="Название"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col>
                <v-text-field
                        v-model="npSettlement.name_ua"
                        label="Название"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>

        <v-btn :loading="loadingButton" v-if="id" @click="update">Сохранить</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import npSettlementService from './../../../api/NPService'
  import moment from 'moment'
  import NPService from "./../../../api/NPService";

  export default {
    name: 'npSettlementEdit',
    props: {
        id: {
            default: null,
        }
    },
    components: {},
    data: () => ({
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      timeModal: false,
      tabLang: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: v => {return !!v.id || 'Нужно заполнить'},
      },
      valid: true,
      npSettlement: {
          name: '',
          name_ua: '',

      },
      loading: true,
      loadingButton: false,
      branches: [],
    }),
    mounted() {
        this.init()
    },
    methods: {
      validate () {
        this.$refs.npSettlementEditForm.validate()
        if(this.npSettlement.name == '' && this.npSettlement.name_ua != ''){
          this.tabLang = 0;
        }
        if(this.npSettlement.name != '' && this.npSettlement.name_ua == ''){
          this.tabLang = 1;
        }
      },
      init(){
        if(this.id) {
          NPService.show(this.id)
            .then(response => {
              this.npSettlement = response.data;
              this.loading = false
            });
        }
      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;



        npSettlementService.update(this.id, {
          name: this.npSettlement.name,
          name_ua: this.npSettlement.name_ua
        }).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Населенный пнукт успешно обновлен';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении населенного пункта';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },

    },
  }
</script>

<style scoped lang="scss">
  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
  .npSettlement-images .v-image{
    max-height: 374px;
  }
  .npSettlement{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
